/* eslint-disable frontApplet/enforce-jsdoc */
import { generateUniqueHash } from '../../Hash/generator';
import IFlagController from './IFlagController';
import IFlag from './IFlag';
import IFileType from '../IFileType';
import ILoadFile from '../LoadFile/ILoadFile';

export default class AppendFlagController implements IFlagController {
	public readonly name = 'append' as const;
	private elementCache: { [uid: string]: HTMLElement };

	constructor(private loadFile: ILoadFile) {
		this.elementCache = {};
	}

	public create(element: HTMLElement) {
		const uid = generateUniqueHash();
		this.elementCache[uid] = element;
		return {
			type: 'append',
			element: {
				uid,
			},
		} as IFlag;
	}

	public async applyFlag(flag: IFlag, fileType: IFileType, filePath: string) {
		if (typeof flag.element !== 'object') {
			throw new Error('File flag of type "append" needs to be object');
		}
		const element = this.elementCache[flag.element.uid];
		if (typeof element === 'undefined') {
			throw new Error('File flag element for "append" not found');
		}
		const loadFileController = this.loadFile[fileType];
		if (typeof loadFileController === 'undefined') {
			throw new Error('File of type "' + fileType + '" cannot be appent');
		}
		await loadFileController.load(filePath, element);
	}
}
